import React from 'react';
import Layout from '../components/layout';
import Hero from '../components/hero';
import Training from '../components/training';

import ide from '../images/ide.png';
import integrations from '../images/integrations.png';
import speakers from '../images/speakers.png';
import reactImage from '../images/react.png';
import reduxImage from '../images/redux.png';

import '../styles/services.css';

export default () => {
    return (
        <Layout active="home">
            <div className="home-screen">
                <h2>Hello,</h2>
                <div className="intro">
                    <p>We are a custom software development shop in Marion, Texas.</p>
                    <p>Our mission is to deliver amazing solutions to amazing companies.</p>
                </div>
            </div>
            <div className="content">
                <div className="blurb">
                    <div>
                        <p>We select the best tool for the job and get the job done. You give us the requirements and we will find the technology stack to satisfy your needs. Our experience allows us to select the tools which will provide a great product in a timely and cost-effective manner.</p>
                        <p>We'll drop the tech talk <span className="behave">(unless you wanna talk nerdy)</span> and explain things using words we are all comfortable with. This ensures we are all on the same page as far as deliverables and end product.</p>
                    </div>
                <div>
                    <p>Our initial consultation will give us a chance to discuss your vision and how we can make that a reality. We have had the opportunity to work with some great people in the New Braunfels and San Antonio area.</p>
                </div>
            </div>

            <div className="small-services">
                <h2>Services we offer</h2>
                <div className="services">
                    <div className="service-type">App Development</div>
                    <div className="service-type">3rd Party Integrations</div>
                    <div className="service-type">Smart Speakers</div>
                    <div className="service-type">Training</div>
                </div>
            </div>
            <div className="yellow-section" style={{marginBottom:"-50px"}}>
                <div className="service-section-text">
                    <h2>App Development</h2>
                    <div>
                        <p>Front-end? Back-end? Web? Mobile? We've got you covered. We can build static business sites, but where we really shine is dynamic web and mobile applications. We can build custom user interactions for collecting, storing, and presenting data in any way imaginable.</p>
                        <p>We can also seamlessly add new functionality to existing applications. We leverage modern frameworks and tools to ensure you get the best product possible.</p>
                    </div>
                </div>
                <img src={ide} alt="IDE-Integrated Development Environment"/>
            </div>
            
            <div className="programming-languages">
                <p>Some of our favorite technologies:</p>
                <div className="language-box-container">
                    <span className="language-box">Javascript</span>
                    <span className="language-box">Node</span>
                    <span className="language-box">React</span>
                    <span className="language-box">Java</span>
                    <span className="language-box">Spring</span>
                    <span className="language-box">C#</span>
                    <span className="language-box">Python</span>
                    <span className="language-box">AWS</span>
                    <span className="language-box">Docker</span>
                    <span className="language-box">Git</span>
                    <span className="language-box">Couchbase</span>
                    <span className="language-box">Kafka</span>
                </div>
            </div>
            <div className="dark-section">
                <div className="service-section-text">
                    <h2>3rd Party Integrations</h2>
                    <p>Whether you want social media integrations, calendars, maps, payment processing. We can do that for you. Our goal is to make the integration between your different systems seamless and a joy to use.</p>
                </div>
                <div className="service-section-text">
                    <div>
                        <p>The concept is simple but the process can be a headache. Let us take care of making the products you know and love work together in harmony.</p>
                        <p>Integrations also allow you to leverage data in creative ways. Want send digital coupons to Facebook followers on rainy days... or after their fifth purchase? Yea we can do that.</p>
                    </div>
                    <img src={integrations} />
                </div>
            </div>
            <div className="white-section">
                <div className="service-section-text">
                    <h2>Smart Speakers</h2>
                    <p>These things are scary...scary awesome! If you want to venture into voice platforms we are ready to help. We can help you create the phrases that will produce the best results.</p>
                </div>
                <img src={speakers} />
                <p>We have experience building these for churches, banks, lazy people, and the list goes on.</p>
            </div>
            <div className="light-section">
                <div className="service-section-text">
                    <h2>Training</h2>
                    <p>Give a man a fish...something something. Honestly we love to teach, we can come up with a lesson plan that is in sync with your practices.</p>
                </div>
                <div className="trainings">
                    <ul>
                        <li>
                            <Training title="Introduction to React" image={reactImage} description="Introduction to React components, state, lifecycle and toolchains" />
                        </li>
                        <li>
                            <Training title="Professional React + Redux" image={reduxImage} description="State management with React. Actions, Reducers, Middleware in depth."/>
                        </li>
                        {/* <li>Introduction to Spring</li>
                        <li>Smart Speaker Zero to Hero</li> */}
                    </ul>
                </div>
                <p>We offer pre-recorded, live, single and multi-day professional development sessions.</p>
            </div>
            </div>
        </Layout>
    )
}